import React from "react";
import RecadastramentoSteps from "./RecadastramentoSteps";
import { RecadastramentoStoreProvider } from "../../../context/RecadastramentoContext";

export default function Recadastramento() {

    return (
        <RecadastramentoStoreProvider>
            <RecadastramentoSteps />
        </RecadastramentoStoreProvider>
    )

}